export function CalculatorCurrencyInput({
  label,
  value,
  onChange,
  hint,
}: {
  label: string
  value: number
  onChange: (v: number) => void
  hint?: string
}) {
  return (
    <div>
      <label className="text-sm font-medium text-charcoal">{label}</label>
      {hint && <p className="mt-0.5 text-xs text-warm-grey">{hint}</p>}
      <div className="relative mt-1.5">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-warm-grey">
          £
        </span>
        <input
          type="text"
          inputMode="numeric"
          value={value.toLocaleString("en-GB")}
          onChange={(e) => {
            const raw = e.target.value.replace(/[^0-9]/g, "")
            const num = parseInt(raw, 10)
            if (!isNaN(num) && num >= 0) onChange(num)
            if (raw === "") onChange(0)
          }}
          className="w-full rounded-lg border border-stone bg-white py-2.5 pl-7 pr-3 text-sm text-charcoal focus:border-red/40 focus:outline-none focus:ring-1 focus:ring-red/20"
        />
      </div>
    </div>
  )
}
